module.exports = __webpack_public_path__ + "img/mask.4b7776b8.png";